// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+mCNn","resendLink":"styles_resendLink__VVkA1"};